"use strict";
import { LDO, MNW, NMR, USDT as USDT_MAINNET } from "uniswap/src/constants/tokens";
export const RESET_APPROVAL_TOKENS = [USDT_MAINNET, LDO, NMR, MNW];
